import { DataBean } from "../DataBean";


export class Role extends DataBean {

    public async getRoleCatalog(idRole: number | null): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getRoleCatalog_Number", [idRole]);
    }

    public async createSuperRole(roleName: string, description: string, idAccount: number): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.bean.securitymanager.Role_createSuperRole_String_String_Number", [roleName, description, idAccount]);
    }

    public async updateRole(bean: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.bean.securitymanager.Role_updateRole_com.advantage.bean.securitymanager.Role", [
            {
                DataBeanProperties: bean,
                DataBeanName: 'com.advantage.bean.securitymanager.Role'
            }
        ]);
    }

    public async deleteRole(bean: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteRole_com.advantage.bean.securitymanager.Role", [
            {
                DataBeanProperties: bean,
                DataBeanName: "com.advantage.bean.securitymanager.Role"
            }
        ]);
    }

}